var _defs, _path, _circle, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.35 84.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-warning{}.cls-2-warning,.cls-3-warning{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2-warning{stroke-width:4.24px;}.cls-3-warning{stroke-width:4.16px;}.cls-2-warning"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-warning",
    d: "M273.62,1061.62a2.61,2.61,0,0,1,2.3,1.36l37,67a2.62,2.62,0,0,1-2.29,3.9H236.58a2.63,2.63,0,0,1-2.29-3.9l37-67a2.61,2.61,0,0,1,2.3-1.36m0-6a8.63,8.63,0,0,0-7.55,4.46l-37,67a8.63,8.63,0,0,0,7.54,12.8h74.08a8.63,8.63,0,0,0,7.55-12.8l-37-67a8.63,8.63,0,0,0-7.55-4.46Z",
    transform: "translate(-227.95 -1055.62)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-warning",
    cx: 45.67,
    cy: 66.89,
    r: 1.83
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3-warning",
    points: "44.44 25.42 45.12 54.93 46.36 54.93 46.91 25.42 44.44 25.42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.a07777b8f6b002eade915f6810c82e55.svg";
export { ForwardRef as ReactComponent };